import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CreateMemberPayload, MemberDatabaseApiResponse, MemberDatabaseQueryParams } from '../types/member-database-public.types';

@Injectable({ providedIn: 'root' })
export class MemberDatabaseService {
  private readonly http = inject(HttpClient);

  public getMembers(filters?: MemberDatabaseQueryParams) {
    let params = new HttpParams();

    if (filters?.country) {
      params = params.set('country', filters.country);
    }
    if (filters?.field) {
      params = params.set('field', filters.field);
    }
    if (filters?.interests?.length) {
      params = params.set('interests__id__in', filters.interests.join(','));
    }
    if (filters?.limit != null) {
      params = params.set('limit', filters.limit);
    }
    if (filters?.offset != null) {
      params = params.set('offset', filters.offset);
    }

    return this.http.get<MemberDatabaseApiResponse>(`${environment.apiUrl}/members/`, { params });
  }

  public createMember(payload: CreateMemberPayload) {
    return this.http.post(`${environment.apiUrl}/members/`, toFormData(payload));
  }
}

function toFormData(payload: CreateMemberPayload): FormData {
  const formData = new FormData();

  for (const [key, value] of Object.entries(payload)) {
    if (value == null) {
      continue;
    }
    if (Array.isArray(value)) {
      value.forEach(item => formData.append(key, String(item)));
    } else if (value instanceof File) {
      formData.append(key, value);
    } else {
      formData.append(key, String(value));
    }
  }

  return formData;
}
